import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH6 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <Typography element="h6" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH6.displayName = 'RichTextH6';

export default RichTextH6;
